import React from "react";
import aromaImg from "./aroma-massage.jpg";   // ⭐ FIXED IMAGE PATH

const AromaMassage = ({ setActiveSection }) => {
  return (
    <section className="bg-white text-gray-900">

      {/* ⭐ TOP BANNER */}
      <div className="relative w-full h-[350px] md:h-[450px]">
        <img
          src={aromaImg}   // ⭐ FIXED
          alt="Aroma Massage Banner"
          className="absolute inset-0 w-full h-full object-cover"
        />

        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/50"></div>

        {/* Center Title */}
        <div className="absolute inset-0 flex items-center justify-center">
          <h1 className="text-4xl md:text-6xl font-bold text-white">
            Aroma Massage
          </h1>
        </div>

        {/* LEFT BOTTOM TITLE */}
        <div className="absolute bottom-0 left-0 bg-black/40 w-full py-4 px-6">
          <h2 className="text-xl md:text-2xl font-semibold text-white">
            Aroma Massage
          </h2>
        </div>

        {/* RIGHT BOTTOM BREADCRUMB */}
        <div className="absolute bottom-0 right-0 bg-black/40 py-4 px-6 flex gap-2 text-white">
          <button
            onClick={() => setActiveSection("home")}
            className="hover:text-amber-300"
          >
            Home
          </button>
          <span>›</span>
          <span className="text-amber-300">Aroma Massage</span>
        </div>
      </div>

      {/* ⭐ MAIN CONTENT */}
      <div className="container mx-auto px-4 py-16 grid md:grid-cols-2 gap-12">

        {/* LEFT TEXT CONTENT */}
        <div>
          <h2 className="text-4xl font-bold mb-6 text-gray-900">
            Rejuvenate With Aroma Therapy
          </h2>

          <p className="text-gray-700 leading-relaxed mb-4">
            Our Aroma Massage combines the healing power of gentle touch with the
            therapeutic benefits of essential oils. Each oil is carefully chosen
            to relax your body, calm your mind, and promote emotional well-being.
          </p>

          <p className="text-gray-700 leading-relaxed mb-4">
            The soothing strokes increase blood circulation, reduce muscular
            tension, and restore your natural body rhythm. Whether you're dealing
            with stress, anxiety, or tiredness, Aroma Massage offers the perfect
            escape into a state of bliss.
          </p>

          <p className="text-gray-700 leading-relaxed mb-6">
            At Aayush Spa, we use premium therapeutic oils that hydrate your skin
            and enhance the overall sensory experience. This treatment is ideal
            for deep relaxation and emotional cleansing.
          </p>

          <button
            onClick={() => setActiveSection("booking")}
            className="bg-amber-900 text-white px-10 py-3 rounded-lg text-lg hover:bg-amber-800 transition"
          >
            Book Now
          </button>
        </div>

        {/* RIGHT IMAGE */}
        <div>
          <img
            src={aromaImg}    // ⭐ FIXED
            alt="Aroma Massage Treatment"
            className="rounded-xl shadow-xl w-full h-[480px] object-cover"
          />
        </div>

      </div>
    </section>
  );
};

export default AromaMassage;
